import { boolean, pgTable, serial, text, timestamp, uniqueIndex, varchar } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';

export const user = pgTable(
  'user',
  {
    id: serial().primaryKey(),
    public_id: typeId('user', 'public_id').notNull(),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
    email: varchar({ length: 50 }).notNull().unique(),
    password: text().notNull(),
    social_auth_only: boolean().notNull().default(false),
    name: varchar({ length: 100 }),
    mfa_enabled: boolean().notNull().default(false),
    mfa_secret: text(),
    free_trial_eligible: boolean().notNull().default(true),
  },
  (t) => [uniqueIndex('user_public_id_uq').on(t.public_id)],
);
